import { api } from "../component/constent"; 
// Change this import to your existing axios/api file if required.

// ======================================================
// GET NEXT SRNO
// ======================================================
export const getTimeOfficeNextSrNo = async () => {
  const response = await api.get( "/entry/time-office/next-srno" );
  return response.data;
};

// ======================================================
// LIST
// ======================================================
export const getTimeOfficeList = async ({
  page = 1,
  limit = 25,
  search = "",
  month,
  year,
}) => {
  const response = await api.get(
    "/entry/time-office",
    {
      params: {
        page,
        limit,
        search,
        month,
        year,
      },
    }
  );

  return response.data;
};

// ======================================================
// ADD
// ======================================================
export const createTimeOffice = async (data) => {
  const response = await api.post(
    "/entry/time-office",
    data
  );

  return response.data;
};

// ======================================================
// UPDATE
// ======================================================
export const updateTimeOffice = async (srno, data) => {
  const response = await api.put(
    `/entry/time-office/${srno}`,
    data
  );

  return response.data;
};

// ======================================================
// DELETE
// ======================================================
export const deleteTimeOffice = async (srno, { month, year }) => {
  const response = await api.delete(
    `/entry/time-office/${srno}`,
    {
      data: {
        month,
        year,
      },
    }
  );

  return response.data;
};